/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionJobRequest } from '../../models/distribution-job-request';
import { DistributionJobResponse } from '../../models/distribution-job-response';

export interface UpdateJob$Params {
  'Active-Tenant-Identifier': string;
  jobId: string;
      body: DistributionJobRequest
}

export function updateJob(http: HttpClient, rootUrl: string, params: UpdateJob$Params, context?: HttpContext): Observable<StrictHttpResponse<DistributionJobResponse>> {
  const rb = new RequestBuilder(rootUrl, updateJob.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('jobId', params.jobId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DistributionJobResponse>;
    })
  );
}

updateJob.PATH = '/distribution-jobs/{jobId}';
